import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { PanelActionGroup } from '../panel-action-group/panel-action-group';
import { PanelHeader } from '../panel-header/panel-header';

const styles = cssMap({
	title: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.050'),
		flexGrow: 1,
	},
	icon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '1.5rem',
		height: '1.5rem',
	},
});

export type PanelHeaderSkeletonProps = {
	shouldShowIcon?: boolean;
	actionsCount?: number;
};

export function PanelHeaderSkeleton({
	shouldShowIcon,
	actionsCount,
}: PanelHeaderSkeletonProps): JSX.Element {
	const showActions = actionsCount !== undefined && actionsCount > 0;
	const ActionSkeletons = showActions
		? Array.from({ length: actionsCount }, (_, index) => (
				<Skeleton key={index} width="1rem" height="1rem" borderRadius={token('radius.tile')} />
			))
		: [];

	return (
		<PanelHeader>
			<Box xcss={styles.title}>
				{shouldShowIcon && (
					<Box xcss={styles.icon}>
						<Skeleton width="1rem" height="1rem" borderRadius={token('radius.tile')} />
					</Box>
				)}
				<Skeleton width={120} height="0.75rem" borderRadius={token('radius.full')} />
			</Box>
			{showActions && <PanelActionGroup>{ActionSkeletons}</PanelActionGroup>}
		</PanelHeader>
	);
}
